'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _boardService = require('../../element/board/boardService');

var boardService = _interopRequireWildcard(_boardService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        fetchBoard: function fetchBoard(args) {
            return dispatch(boardService.fetchBoard(args));
        }
    };
};

/**
 * This component is being used to separate the redirection logic out of the WorkspaceInitContainer to account
 * for the scenario that the root URL is loaded (e.g. www.milanote.com) because sub routes are not invoked in
 * this version of React Router when the current route matches exactly ('/').
 */

exports.default = function (DecoratedComponent) {
    var _dec, _class;

    var WorkspacBoardFetchDecorator = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
        _inherits(WorkspacBoardFetchDecorator, _React$Component);

        function WorkspacBoardFetchDecorator() {
            _classCallCheck(this, WorkspacBoardFetchDecorator);

            return _possibleConstructorReturn(this, (WorkspacBoardFetchDecorator.__proto__ || Object.getPrototypeOf(WorkspacBoardFetchDecorator)).apply(this, arguments));
        }

        _createClass(WorkspacBoardFetchDecorator, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
                var _props = this.props,
                    currentBoardId = _props.currentBoardId,
                    fetchBoard = _props.fetchBoard;


                if (!currentBoardId) return;

                fetchBoard({ boardId: currentBoardId, loadNextBoards: true, loadAncestors: true });
            }
        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                var fetchBoard = nextProps.fetchBoard,
                    currentBoardId = nextProps.currentBoardId,
                    socketConnected = nextProps.socketConnected,
                    isCurrentBoardFetched = nextProps.isCurrentBoardFetched,
                    isCurrentBoardFetching = nextProps.isCurrentBoardFetching;


                if (!currentBoardId || !socketConnected) return;

                // Only fetch the board on property change if the board ID has changed
                if (currentBoardId !== this.props.currentBoardId) {
                    return fetchBoard({ boardId: currentBoardId, loadNextBoards: true });
                }

                // Handles the case that the current board is being fetched, but then errors during the fetch, but has not
                // been marked as being fetched due to the helper service
                if (!isCurrentBoardFetched && !isCurrentBoardFetching) {
                    return fetchBoard({ boardId: currentBoardId, loadNextBoards: true });
                }

                // Fetch the board if the socket changes from disconnected to connected
                if (socketConnected && !this.props.socketConnected) {
                    fetchBoard({ boardId: currentBoardId, loadNextBoards: true });
                }
            }
        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(DecoratedComponent, this.props);
            }
        }]);

        return WorkspacBoardFetchDecorator;
    }(_react2.default.Component)) || _class);


    WorkspacBoardFetchDecorator.propTypes = {
        currentBoardId: _propTypes2.default.string,
        isCurrentBoardFetched: _propTypes2.default.bool,
        isCurrentBoardFetching: _propTypes2.default.bool,
        socketConnected: _propTypes2.default.bool,
        fetchBoard: _propTypes2.default.func
    };

    return WorkspacBoardFetchDecorator;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/decorators/workspaceBoardFetchDecorator.js
// module id = 2155
// module chunks = 0